import createReducer from "../../reducers/createReducer";
import {
  FETCH_FEATURE_FLAGS_REQUEST,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
  UPDATE_FEATURE_FLAG_REQUEST,
  UPDATE_FEATURE_FLAG_SUCCESS,
  UPDATE_FEATURE_FLAG_FAILURE,
  FETCH_FEATURE_FLAG_REQUEST,
  FETCH_FEATURE_FLAG_SUCCESS,
  FETCH_FEATURE_FLAG_FAILURE,
} from "./types";

const initialState = {
  items: [],
  loading: false,
  error: null,
  updatingByName: {},
  fetchingByName: {},
};

const resolveState = (state = {}, newState = {}) =>
  Object.assign({}, state, newState);

export const featureFlagsReducer = createReducer(initialState, {
  [FETCH_FEATURE_FLAGS_REQUEST](state) {
    return resolveState(state, {
      loading: true,
      error: null,
    });
  },
  [FETCH_FEATURE_FLAGS_SUCCESS](state, action) {
    return resolveState(state, {
      loading: false,
      items: Array.isArray(action.payload) ? action.payload : [],
      error: null,
    });
  },
  [FETCH_FEATURE_FLAGS_FAILURE](state, action) {
    return resolveState(state, {
      loading: false,
      error: action.payload,
    });
  },
  [UPDATE_FEATURE_FLAG_REQUEST](state, action) {
    const name = action?.payload?.name;
    return resolveState(state, {
      error: null,
      updatingByName: {
        ...state.updatingByName,
        ...(name ? { [name]: true } : {}),
      },
    });
  },
  [UPDATE_FEATURE_FLAG_SUCCESS](state, action) {
    const { name, flag } = action.payload || {};
    const nextItems = state.items.map((item) =>
      item?.name === name ? { ...item, ...flag } : item
    );
    return resolveState(state, {
      items: nextItems,
      error: null,
      updatingByName: {
        ...state.updatingByName,
        ...(name ? { [name]: false } : {}),
      },
    });
  },
  [UPDATE_FEATURE_FLAG_FAILURE](state, action) {
    const { name, error } = action.payload || {};
    return resolveState(state, {
      error: error || "Unable to update feature flag.",
      updatingByName: {
        ...state.updatingByName,
        ...(name ? { [name]: false } : {}),
      },
    });
  },
  [FETCH_FEATURE_FLAG_REQUEST](state, action) {
    const name = action?.payload?.name;
    return resolveState(state, {
      error: null,
      fetchingByName: {
        ...state.fetchingByName,
        ...(name ? { [name]: true } : {}),
      },
    });
  },
  [FETCH_FEATURE_FLAG_SUCCESS](state, action) {
    const { name, flag } = action.payload || {};
    const hasExisting = state.items.some((item) => item?.name === name);
    const nextItems = hasExisting
      ? state.items.map((item) => (item?.name === name ? { ...item, ...flag } : item))
      : [...state.items, flag];

    return resolveState(state, {
      items: nextItems,
      error: null,
      fetchingByName: {
        ...state.fetchingByName,
        ...(name ? { [name]: false } : {}),
      },
    });
  },
  [FETCH_FEATURE_FLAG_FAILURE](state, action) {
    const { name, error } = action.payload || {};
    return resolveState(state, {
      error: error || "Unable to fetch feature flag.",
      fetchingByName: {
        ...state.fetchingByName,
        ...(name ? { [name]: false } : {}),
      },
    });
  },
});
